import {
  faCheck,
  faMagnifyingGlass,
  faPenToSquare,
  faPlus,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { message } from "antd";
import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  FloatingLabel,
  ListGroup,
  Modal,
  Row,
  Form,
  Alert,
  InputGroup,
} from "react-bootstrap";
import Loader from "../../../components/Loader";
import Message from "../../../components/Message";
import { useDispatch, useSelector } from "react-redux";
import {
  calculateAverageRating,
  generateServiceName,
} from "../../../controllers/addingnew";
import { MAID_CREATE_RESET } from "../../../redux/Constants/maidConstants";
import usePermissions from "../../../hook/userPermission";
import {
  clearMaidState,
  createMaid,
  deleteMaid,
  getAllMaids,
  updateMaid,
} from "../../../redux/slices/maidSlice";

const AirbnbList = ({ toAddMaid, toDeleteMaid }) => {
  const { hasPermission } = usePermissions();
  const [validated, setValidated] = useState(false);
  const [editValidated, setEditValidated] = useState(false);
  const [nameError, setNameError] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredMaids, setFilteredMaids] = useState([]);
  const [show, setShow] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [maidToDelete, setMaidToDelete] = useState(null);
  const [maidToEdit, setMaidToEdit] = useState(null);
  const [formData, setFormData] = useState({
    unitName: "",
    address: "",
    type: "airbnb",
    email: "",
    employId: "NaN",
  });
  const [updatedFormData, setUpdatedFormData] = useState({
    unitName: "",
    address: "",
  });
  const [confirmationMessage, setConfirmationMessage] = useState("");

  const { userInfo } = useSelector((state) => state.userLogin);

  const {
    airbnbs: maids,
    fetchLoading,
    fetchError,
    createLoading,
    deleteSuccess,
    updateSuccess,
    createError,
    createSuccess,
  } = useSelector((state) => state.maids);

  const dispatch = useDispatch();

  const hotelId = userInfo.isAdmin == true ? userInfo._id : userInfo.hotel;
  const isB2c = !userInfo?.model.b2b;

  const handleUnitNameChange = (e) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      unitName: e.target.value,
    }));
    // setServiceNameError(false);
  };
  const handleAddressChange = (e) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      unitAddress: e.target.value,
    }));
    // setServiceNameError(false);
  };
  const handleClose = () => {
    dispatch(clearMaidState());
    setValidated(false);
    setShow(false);
    setNameError(false);
    setFormData({
      unitName: "",
      unitAddress: "",
      type: "airbnb",
      email: "",
      employId: "NaN",
    });
  };

  const handleDeleteModal = () => setDeleteModal(false);
  const handleEditClose = () => setEditModal(false);

  const handleEditShow = () => setEditModal(true);

  const handleEdit = async (e) => {
    e.preventDefault();
    const form = e.currentTarget;

    if (form.checkValidity() === false) {
      e.stopPropagation();
    } else {
      try {
        await dispatch(
          updateMaid({
            id: maidToEdit._id,
            unitName: updatedFormData.unitName,
            unitAddress: updatedFormData.unitAddress,
          })
        ).unwrap();

        message.success("Details updated!");
        handleEditClose();
        dispatch(clearMaidState());
      } catch (error) {
        console.error("Error updating maid:", error);
        message.error(error || "Failed to update details.");
      }
    }
    setEditValidated(true);
  };
  const handleDelete = async () => {
    if (maidToDelete) {
      try {
        await dispatch(
          deleteMaid({ maidId: maidToDelete, maidType: "airbnb" })
        ).unwrap();

        message.success("Unit deleted!");
        setMaidToDelete(null);
        handleDeleteModal();
        dispatch(clearMaidState());
      } catch (error) {
        console.error("Error deleting maid:", error);
        message.error(error || "Failed to delete.");
      }
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.currentTarget;

    if (form.checkValidity() === false) {
      e.stopPropagation();
    } else {
      const isDuplicateUnitName = maids.some(
        (maid) =>
          maid.unitName.toLowerCase().replace(/\s/g, "") ===
          formData.unitName.toLowerCase().replace(/\s/g, "")
      );
      if (isDuplicateUnitName) {
        setNameError(true);
        setValidated(false);
        return;
      } else {
        // Reset the error state
        setNameError(false);

        try {
          await dispatch(
            createMaid({
              unitName: formData.unitName,
              type: formData.type,
              unitAddress: formData.unitAddress,
              hotel: hotelId,
            })
          ).unwrap();

          message.success("Unit added successfully!");
          handleClose();
        } catch (err) {
          message.error(err || "Failed to add attendant.");
        }
      }
    }
    setValidated(true);
  };

  useEffect(() => {
    dispatch(getAllMaids({ hotelId }));
    if (maidToEdit != null) {
      setUpdatedFormData({
        unitName: maidToEdit.unitName,
        unitAddress: maidToEdit.unitAddress,
      });
    }
  }, [dispatch, hotelId, maidToEdit, updateSuccess, deleteSuccess]);

  const styles = {
    shadow: {
      boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
    },
  };
  return (
    <>
      <Alert
        className="mt-3"
        show={!!confirmationMessage}
        variant={
          confirmationMessage.includes("successfully") ? "success" : "danger"
        }
        onClose={() => setConfirmationMessage("")}
      >
        {confirmationMessage}
      </Alert>
      {/* --------------------------------------------- EDIT MODAL --------------------------------------------- */}
      <Modal
        show={editModal}
        onHide={handleEditClose}
        backdrop="static"
        centered
      >
        <Modal.Header className="bg-primary">
          <Modal.Title className="mx-auto text-light">Edit Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form noValidate validated={editValidated} onSubmit={handleEdit}>
            <Row>
              <Col sm={12}>
                <Form.Group className="mb-3" controlId="formBasicEmail">
                  <Form.Label>Unit name</Form.Label>
                  <Form.Control
                    required
                    type="text"
                    value={updatedFormData.unitName}
                    onChange={(e) => {
                      setUpdatedFormData((prevFormData) => ({
                        ...prevFormData,
                        unitName: e.target.value,
                      }));
                    }}
                    placeholder="Enter Unit Name"
                  />
                </Form.Group>
              </Col>
              <Col sm={12}>
                <Form.Group className="mb-3" controlId="formBasicEmail">
                  <Form.Label>Address</Form.Label>
                  <Form.Control
                    required
                    type="text"
                    value={updatedFormData.unitAddress}
                    onChange={(e) => {
                      setUpdatedFormData((prevFormData) => ({
                        ...prevFormData,
                        unitAddress: e.target.value,
                      }));
                    }}
                    placeholder="Enter Address"
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row className="mt-3">
              <Col sm="auto" className="ms-auto">
                <Button
                  variant="secondary"
                  className="mx-3"
                  onClick={handleEditClose}
                >
                  Close
                </Button>
                <Button variant="success" type="submit">
                  Save
                </Button>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>
      {/* ------------------------------------------ DELETE MODAL ----------------------------------------- */}
      <Modal
        show={deleteModal}
        onHide={handleDeleteModal}
        backdrop="static"
        centered
      >
        <Modal.Body className="p-4">
          <b>Are you sure you want to remove this unit?</b>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleDeleteModal}>
            Cancel
          </Button>
          <Button variant="danger" onClick={handleDelete}>
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
      {/* --------------------------------------------- ADD NEW MODAL ------------------------------------------- */}
      <Modal show={show} onHide={handleClose} backdrop="static" centered>
        <Modal.Header className="bg-primary">
          <Modal.Title className="mx-auto text-light">
            Add a new unit
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {createLoading ? (
            <Loader />
          ) : (
            <Form noValidate validated={validated} onSubmit={handleSubmit}>
              <FloatingLabel
                className="my-3"
                controlId="floatingInput"
                label="Unit name"
                value={formData.unitName}
                onChange={handleUnitNameChange}
              >
                <Form.Control required type="text" placeholder="Unit name" />
                {nameError ? (
                  <Form.Text className="text-danger">
                    This unit name already exists!
                  </Form.Text>
                ) : (
                  <></>
                )}
              </FloatingLabel>

              <FloatingLabel
                className="my-3"
                controlId="floatingId"
                label="Address"
                value={formData.unitAddress}
                onChange={handleAddressChange}
              >
                <Form.Control required type="text" placeholder="Address" />
              </FloatingLabel>

              <Row className="my-3">
                <Col sm="auto" className="ms-auto">
                  <Button
                    variant="secondary"
                    className="me-3"
                    onClick={handleClose}
                  >
                    Cancel
                  </Button>
                  <Button className="px-4" variant="primary" type="submit">
                    Add
                  </Button>
                </Col>
              </Row>
            </Form>
          )}
        </Modal.Body>
      </Modal>
      {/* -------------------------------------------- Add new button ------------------------------------------------ */}
      <Row className="m-0">
        <Col>
          {hasPermission("toAddMaid") ? (
            <>
              <Row className="align-items-center mt-4">
                <Col sm={3} className="ms-auto p-0">
                  <InputGroup className="ms-auto border border-1 rounded-4 p-1">
                    <Button
                      className="bg-transparent border-0 p-1"
                      id="button-addon1"
                    >
                      <FontAwesomeIcon
                        icon={faMagnifyingGlass}
                        className="text-primary mx-2"
                      />
                    </Button>
                    <Form.Control
                      className="border-0 p-0"
                      aria-label="search"
                      aria-describedby="basic-addon1"
                      placeholder="Search"
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                    />
                  </InputGroup>
                </Col>
                <Col md="auto">
                  <Button
                    className="rounded-4"
                    variant="outline-success"
                    onClick={() => {
                      setShow(true);
                      setValidated(false);
                    }}
                  >
                    <FontAwesomeIcon icon={faPlus} className="me-2" /> Add New
                  </Button>
                </Col>
              </Row>
            </>
          ) : (
            <></>
          )}
          {/* -------------------------- Top Row --------------------------------- */}
          <Row className="py-4">
            <Col className="p-4 rounded-4" style={styles.shadow}>
              <Row>
                <Col md={3} className="text-primary fw-semibold fs-5">
                  Unit Name
                </Col>
                <Col md={4} className="text-primary fw-semibold fs-5">
                  Address
                </Col>
                <Col
                  md={3}
                  className="text-primary fw-semibold fs-5 text-center"
                >
                  Ratings
                </Col>
                <Col
                  md={2}
                  className="text-primary fw-semibold fs-5 text-center"
                >
                  Action
                </Col>
              </Row>
              <hr className="my-3" />
              {/* ----------------------------------------------- Units List------------------------------------------ */}
              <Row>
                <Col>
                  {fetchLoading ? (
                    <Loader />
                  ) : fetchError ? (
                    <Message>{fetchError}</Message>
                  ) : (
                    <>
                      {maids
                        .filter((maid) =>
                          maid.unitName
                            .toLowerCase()
                            .includes(searchQuery.toLowerCase())
                        )
                        .map((maid, index) => (
                          <>
                            <Row key={index} className="align-items-center">
                              <Col md={3}>
                                <Row className="align-items-center">
                                  <Col sm="auto" className="ps-3">
                                    {maid.unitName}
                                  </Col>
                                </Row>
                              </Col>
                              <Col md={4} className="text-muted fst-italic">
                                {maid.unitAddress}
                              </Col>
                              <Col md={3} className="text-success text-center">
                                {calculateAverageRating(maid.ratings).toFixed(
                                  1
                                )}
                              </Col>
                              <Col className="ms-auto me-3" sm="auto">
                                {hasPermission("toAddMaid") && (
                                  <Button
                                    className="mx-2"
                                    variant="outline-dark"
                                    onClick={() => {
                                      setMaidToEdit(maid);
                                      setEditModal(true);
                                    }}
                                  >
                                    <FontAwesomeIcon icon={faPenToSquare} />
                                  </Button>
                                )}
                                {hasPermission("toDeleteMaid") && (
                                  <Button
                                    className="mx-2"
                                    variant="outline-danger"
                                    onClick={() => {
                                      setDeleteModal(true);
                                      setMaidToDelete(maid._id);
                                    }}
                                  >
                                    <FontAwesomeIcon icon={faTrash} />
                                  </Button>
                                )}
                              </Col>
                            </Row>
                            <hr className="my-2" />
                          </>
                        ))}
                    </>
                  )}
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};

export default AirbnbList;
